var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { EventEmitter } from '@angular/core';
var CampaignTermComponent = /** @class */ (function () {
    function CampaignTermComponent() {
        this.selectEvent = new EventEmitter();
        this.deleteEvent = new EventEmitter();
        this.editEvent = new EventEmitter();
    }
    Object.defineProperty(CampaignTermComponent.prototype, "selected", {
        get: function () {
            // return this.campaignTerm ? (this.campaignTerm.required || this.campaignTerm.isUsed) : false;
            return this.campaignTerm ? this.campaignTerm.selected : false;
        },
        enumerable: true,
        configurable: true
    });
    CampaignTermComponent.prototype.ngOnInit = function () {
    };
    CampaignTermComponent.prototype.onSelect = function (e) {
        if (!this.campaignTerm) {
            return;
        }
        if (!this.isReadOnly) {
            this.campaignTerm.selected = !this.campaignTerm.selected;
            this.selectEvent.emit({
                selected: this.selected,
                campaignTerm: this.selected,
                event: e
            });
        }
    };
    CampaignTermComponent.prototype.delete = function (e, termId) {
        e.stopPropagation();
        this.deleteEvent.emit(termId);
    };
    CampaignTermComponent.prototype.edit = function (e, term) {
        e.stopPropagation();
        this.editEvent.emit(__assign({}, term));
    };
    return CampaignTermComponent;
}());
export { CampaignTermComponent };



// WEBPACK FOOTER //
// ./src/app/main/campaigns-add/campaign-term/campaign-term.component.ts.pre-build-optimizer.js